import { FC } from 'react';
import { Box, Flex, Text, IconButton, useDisclosure } from '@chakra-ui/react';
import { NavigationLink, NavigationLogo, NavigationProfile } from '../../types/Navigation';
import { ICON_BY_NAME } from '../Icons/Icon';
import { CbNavigationLink } from './CbNavigationLink';
import { GroupMeWidget } from 'ui/GroupMeWidget';
import { useCurrentUser } from '../../../hooks/useCurrentUser';
import { CbDrawer } from '../CbDrawer';
import { CbAvatar } from '../CbAvatar';
export interface CbNavigationDrawerProps {
  links: NavigationLink[];
  logo?: NavigationLogo;
  profile?: NavigationProfile;
}
const HeaderContent = ({
  name,
  image
}) => {
  return <Flex alignItems="center" justifyContent="" width="100%" height="100%" marginTop={14} paddingX={8} gap={8} data-sentry-element="Flex" data-sentry-component="HeaderContent" data-sentry-source-file="CbNavigationDrawer.tsx">
      <CbAvatar avatarSize="xl" name={name} image={image} data-sentry-element="CbAvatar" data-sentry-source-file="CbNavigationDrawer.tsx" />
      <Text fontSize="md" color="luigisPants.500" data-sentry-element="Text" data-sentry-source-file="CbNavigationDrawer.tsx">
        {name}
      </Text>
    </Flex>;
};
export const CbNavigationDrawer: FC<CbNavigationDrawerProps> = ({
  links,
  profile
}) => {
  const currentUser = useCurrentUser();
  const needsToConnectGroupMe = currentUser?.needsToConnectGroupMe;
  const {
    isOpen,
    onOpen,
    onClose
  } = useDisclosure();
  const getNavigationLink = link => <CbNavigationLink key={link.label} as={link.as} href={link.href} isActive={link.isActive} icon={link.icon} isExternal={link.isExternal} isMobile renderAsButton={link.subLinks?.length ? true : link.renderAsButton} width="100%"
  // I'm sure there's a better way to do this, but I'm not sure what it is
  // quite yet. Will revisit along with the hooks descrepancy issue.
  onClick={link.onClick || onClose} data-sentry-element="CbNavigationLink" data-sentry-component="getNavigationLink" data-sentry-source-file="CbNavigationDrawer.tsx">
      {link.label}
    </CbNavigationLink>;
  return <>
      <IconButton aria-label="Menu" backgroundColor="transparent" color="white" colorScheme="transparent" data-testid="menu_button" onClick={isOpen ? onClose : onOpen} _focus={{
      outline: 'none !important'
    }} data-sentry-element="IconButton" data-sentry-source-file="CbNavigationDrawer.tsx">
        <Box data-sentry-element="Box" data-sentry-source-file="CbNavigationDrawer.tsx">
          {needsToConnectGroupMe && <ICON_BY_NAME.cautioncircle position="relative" marginRight={-1} marginBottom={-3} color="kirby.500" />}
          {isOpen ? <ICON_BY_NAME.close width="21px" height="14px" data-test-id="close_icon" /> : <CbAvatar avatarSize="sm" borderRadius="50%" borderWidth="2px" borderColor="white" data-testid="avatar" name={profile?.name} image={profile?.imageUrl} />}
        </Box>
      </IconButton>
      <CbDrawer isMobile={true} isOpen={isOpen} onClose={onClose} customHeader={profile && <HeaderContent name={profile.name} image={profile.imageUrl} />} data-testid="navigation-drawer" data-sentry-element="CbDrawer" data-sentry-source-file="CbNavigationDrawer.tsx">
        {links.map(link => getNavigationLink(link))}
        <Flex justifyContent={'center'} paddingX={4} data-sentry-element="Flex" data-sentry-source-file="CbNavigationDrawer.tsx">
          <GroupMeWidget data-sentry-element="GroupMeWidget" data-sentry-source-file="CbNavigationDrawer.tsx" />
        </Flex>
      </CbDrawer>
    </>;
};